import { createFileRoute } from "@tanstack/react-router";
import OscarInsurance, { config } from "@/pages/OscarInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/oscar-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Oscar Health TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Oscar Health insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Oscar plan in Coral.",
        },
        {
          property: "og:title",
          content: "Oscar Health TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Oscar Health insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Oscar plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/oscar-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/oscar-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <OscarInsurance />;
}
